module.exports = __webpack_public_path__ + "static/images/hot-active.de8fd83.png";